import { render } from "./BindBankPage.vue?vue&type=template&id=22e83314&scoped=true"
import script from "./BindBankPage.vue?vue&type=script&lang=js"
export * from "./BindBankPage.vue?vue&type=script&lang=js"

import "./BindBankPage.vue?vue&type=style&index=0&id=22e83314&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e83314"]])

export default __exports__